import { render, staticRenderFns } from "./TreeNodeFacet.vue?vue&type=template&id=096fb4f8&"
import script from "./TreeNodeFacet.vue?vue&type=script&lang=js&"
export * from "./TreeNodeFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports